import { marked } from 'marked'

// ── Overview tab ──────────────────────────────────────────────────────────────
export function OverviewTab({ readme, scanning }: { readme: string | null; scanning: boolean }) {
  if (scanning && !readme) {
    return (
      <div style={{ color: 'var(--text3)', fontFamily: 'var(--mono)', fontSize: '0.8rem' }}>
        <span className="spinner" style={{ width: 10, height: 10, marginRight: 8 }} />
        Scan pending - README will appear here once complete.
      </div>
    )
  }

  if (readme) {
    return (
      <div
        className="markdown-body"
        dangerouslySetInnerHTML={{ __html: marked.parse(readme) as string }}
      />
    )
  }

  // No readme found
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem', color: 'var(--text2)' }}>
        No <span style={{ color: 'var(--accent)' }}>README.md</span> was found in this module.
      </div>
      <div style={{ fontSize: '0.78rem', color: 'var(--text2)', lineHeight: 1.7 }}>
        Adding a README helps users understand how to use this module. Terramantle will automatically
        extract and display it on the next published version.
      </div>
      <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 8, padding: '14px 16px', display: 'grid', gap: 10 }}>
        <div style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text3)' }}>// quick start</div>
        <div style={{ fontSize: '0.78rem', color: 'var(--text2)', lineHeight: 1.8 }}>
          Auto-generate a README using <span style={{ fontFamily: 'var(--mono)', color: 'var(--accent)' }}>terraform-docs</span>:
        </div>
        <pre style={{ fontFamily: 'var(--mono)', fontSize: '0.78rem', color: 'var(--green)', margin: 0 }}>
          terraform-docs markdown table . {'>'} README.md
        </pre>
        <div style={{ fontSize: '0.75rem', color: 'var(--text3)', lineHeight: 1.7 }}>
          Recommended sections: <span style={{ color: 'var(--text2)' }}>Description · Requirements · Providers · Inputs · Outputs · Examples</span>
        </div>
      </div>
    </div>
  )
}
